const PageHero = ({ eyebrow, title, intro, children }) => (
  <section className="bg-[#000000] text-white pt-40 pb-28">
    <div className="container-kc">
      {eyebrow && (
        <div className="flex items-center gap-3 mb-6">
          <span className="hairline--gold" />
          <span className="eyebrow eyebrow--gold">{eyebrow}</span>
        </div>
      )}
      <h1 className="h-display h-display--inverse text-4xl md:text-6xl lg:text-7xl max-w-4xl">{title}</h1>
      {intro && (
        <p className="text-white/80 mt-8 max-w-2xl text-base md:text-lg leading-relaxed">{intro}</p>
      )}
      {children}
    </div>
  </section>
);

export default PageHero;
